import React from "react";
import { Link } from "react-router-dom";

export default function Brand({ size = "md", showTag = true, className = "" }) {
  const dim = size === "sm" ? 32 : size === "lg" ? 48 : 40;
  const titleCls = size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-2xl";
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="brand-link">
      <img
        src="/nitisoft-logo.png"
        alt="NitiSoft"
        width={dim}
        height={dim}
        className="object-contain rounded"
        style={{ height: dim, width: dim }}
      />
      <div>
        <div className={`font-display leading-none ${titleCls}`}>NITISOFT</div>
        {showTag && <div className="label-mono">Auction Platform</div>}
      </div>
    </Link>
  );
}
